import i18n from '@/lang/i18n'

export const DAY_OF_WEEK = {
    MONDAY: { arrayPosition: 1, code: 'MONDAY', translatedName: i18n.t('configuration.modal.calendar.monday') },
    TUESDAY: { arrayPosition: 2, code: 'TUESDAY', translatedName: i18n.t('configuration.modal.calendar.tuesday') },
    WEDNESDAY: { arrayPosition: 3, code: 'WEDNESDAY', translatedName: i18n.t('configuration.modal.calendar.wednesday') },
    THURSDAY: { arrayPosition: 4, code: 'THURSDAY', translatedName: i18n.t('configuration.modal.calendar.thursday') },
    FRIDAY: { arrayPosition: 5, code: 'FRIDAY', translatedName: i18n.t('configuration.modal.calendar.friday') },
    SATURDAY: { arrayPosition: 6, code: 'SATURDAY', translatedName: i18n.t('configuration.modal.calendar.saturday') },
    SUNDAY: { arrayPosition: 0, code: 'SUNDAY', translatedName: i18n.t('configuration.modal.calendar.sunday') }
}
